/**
 * Name: New Playlist Page
 * Author: @Gaurav
 * Date: 19-07-21
 */
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import Button from '../../components/Button';
import '../NewPlaylist/NewPlaylist.scss';
import { playlistActions } from '../../actions';
import { _showAlert } from '../../utils';
import { playlistStore } from '../../store';

function NewPlaylist() {
  const [playlistName, setPlaylistName] = useState('');
  const [isLoading, setLoading] = useState(false);

  // Router
  const history = useHistory();

  // Get Query Params from the URL
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const plan = queryParams.get('plan');

  // Zustand Playlist
  const { setUnlimitedPlaylist, setRadioPlaylist } = playlistStore((state) => ({
    setUnlimitedPlaylist: state.setUnlimitedPlaylists,
    setRadioPlaylist: state.setRadioPlaylists,
  }));

  /**
   * it will handle the create playlist api request
   */

  const handleCreatePlaylist = (e) => {
    e.preventDefault();
    const createPlaylist = async () => {
      const createPlaylistRes = await playlistActions.createPlaylist({
        name: playlistName,
        songs: [],
        type: plan.toUpperCase(),
      });

      if (createPlaylistRes?.id) {
        _showAlert('Playlist created successfully', 'success', 4000);
        setUnlimitedPlaylist([]);
        setRadioPlaylist([]);
        history.goBack();
      }
    };

    if (playlistName !== '') {
      setLoading(true);
      createPlaylist();
    }
  };

  return (
    <>
      <NavBar
        data="New Playlist"
        icon={Settings}
        currentRouteName="New Playlist"
        breadcrumbsPath={[
          { name: 'Playlist' },
          plan === 'unlimited'
            ? { name: 'Unlimited Playlist', link: '/unlimited-playlist' }
            : { name: 'Radio Playlist', link: '/radio-playlist' },
        ]}
      />
      <div className="content empty_row">
        <form className="create_playlist_row" onSubmit={handleCreatePlaylist}>
          <input placeholder="Playlist Name" type="text" onChange={(e) => setPlaylistName(e.target.value)} />
          <Button isLoading={isLoading} style={{ marginInline: 'auto' }} className="button primary round_btn">
            Create Playlist
          </Button>
        </form>
      </div>
    </>
  );
}

export default NewPlaylist;

